import React from 'react';
import { Link } from 'react-router-dom';
import './Ournetwork.css';

function Ournetwork() {
    // Array of network partners with their images, names, and links
    const networkPartners = [
        { name: "Chamber", image: "./Pics/Chamber.jpg", link: "/chamber" },
        { name: "Piffa", image: "./Pics/Piffa.jpg", link: "/piffa" },
        { name: "Fiata", image: "./Pics/Fiata.jpg", link: "/fiata" },
        { name: "Mundu", image: "./Pics/Mundu.jpg", link: "/mundu" },
        { name: "Airsial", image: "./Pics/Airsial.jpg", link: "/airsial" },
        { name: "Sictl", image: "./Pics/Sictl.jpg", link: "/sictl" }
    ];

    return (
        <div className="main-ournetwork-container">
            {/* Hero section with image and overlay text */}
            <div className="ournetwork-hero">
                <div className="ournetwork-overlay">
                    <h1>Our Network</h1>
                </div>
            </div>
            
            {/* White gap */}
            <div className="white-gap"></div>
            
            {/* Network Partners Section */}
            <div className="network-partners-section">
                <h2>Our Network</h2>
                <div className="partners-grid">
                    {networkPartners.map((partner, index) => (
                        <Link to={partner.link} key={index} className="partner-link">
                            <div className="partner-box">
                                <img src={partner.image} alt={partner.name} />
                                <h3 >{partner.name}</h3>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Ournetwork;
